import { KYMW0500Component } from './kymw0500.component';
import { RelatedDataModel } from './vo/related-data.model';

/**
 * 紐付設定画面の値を管理するクラス
 *
 * @export KYMW0500Model
 * @class KYMW0500Model
 */
export class KYMW0500Model {

  kymw0500Component: KYMW0500Component;

  // 編集モード
  public editMode: boolean = <boolean>false;
  // 処理モード
  public processMode: string = <string>'';
  // 処理区分
  public processDiv: string = <string>'';
  // 受注コード
  public orderCode: string = <string>'';
  // 媒体区分
  public mediumType: string = <string>'';
  // 代表商品Ｐコード
  public mainPCode: string = <string>'';
  // 生協ロック
  public lockedIB: boolean = <boolean>false;
  public lockedTO: boolean = <boolean>false;
  public lockedGU: boolean = <boolean>false;
  public lockedTI: boolean = <boolean>false;
  public lockedSA: boolean = <boolean>false;
  public lockedTK: boolean = <boolean>false;
  public lockedNA: boolean = <boolean>false;
  public lockedNI: boolean = <boolean>false;
  public lockedKU: boolean = <boolean>false;

  private COOP_COUNT: number = <number>9;

  // 紐付商品データリスト
  public relatedDataList: Array<RelatedDataModel> = new Array<RelatedDataModel>();
  // ロックPコード
  public lockPCodeList: Array<any> = new Array<any>();

  public pCode0: string = <string>'';

  /**
   * 取得した紐付設定画面データを反映する
   *
   * @param data : Object		サーバから受信したデータ
   */
  public setRelatedData(relatedData: any): void {
    // 作業用配列
    const list: Array<any> = new Array<any>();

    let i = Number(0);
    // 子商品群チェックボックスを非活性
    this.lockedIB = false;
    this.lockedTO = false;
    this.lockedGU = false;
    this.lockedTI = false;
    this.lockedSA = false;
    this.lockedTK = false;
    this.lockedNA = false;
    this.lockedNI = false;
    this.lockedKU = false;

    if (relatedData && relatedData.length > 1) {
    this.processMode = '2';                                                   // 更新モード
      for (const tmpData of relatedData) {
        this.relatedDataList[i] = this.getRelatedDataVO(this.relatedDataList[i], tmpData, false, i);
        i++;
      }

    } else {
      this.processMode = '1';                                                   // 新規モード
      this.relatedDataList[i] = this.getRelatedDataVO(this.relatedDataList[i], relatedData[0], false, i);
      i++;
    }

    for (let j: number = i; j < this.COOP_COUNT; j++) {
      this.relatedDataList[j] = this.getRelatedDataVO(this.relatedDataList[j], null, false, j);
    }

    this.setCoopLock();
  }

  /**
   * 取得した商品データを反映する
   *
   * @param {Object} data サーバから受信したデータ
   * @param {number} index 対象行Index
   * @memberof KYMW0500Model
   */
  public setGoodsData(data: Object, index: number): void {
    this.relatedDataList[index] = this.getRelatedDataVO(this.relatedDataList[index], data, true, index);
    this.setCoopLock();
  }

  /**
   * 生協単位のロックを行う
   */
  public setCoopLock(): void {

    for (let i = Number(0); i < this.relatedDataList.length; i++) {

      const tempData: RelatedDataModel = this.relatedDataList[i];

      if (this.lockedIB) {
        tempData.enabledIB = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbIB[i], false);
      }
      if (this.lockedTO) {
        tempData.enabledTO = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTO[i], false);
      }
      if (this.lockedGU) {
        tempData.enabledGU = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbGU[i], false);
      }
      if (this.lockedTI) {
        tempData.enabledTI = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTI[i], false);
      }
      if (this.lockedSA) {
        tempData.enabledSA = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbSA[i], false);
      }
      if (this.lockedTK) {
        tempData.enabledTK = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTK[i], false);
      }
      if (this.lockedNA) {
        tempData.enabledNA = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbNA[i], false);
      }
      if (this.lockedNI) {
        tempData.enabledNI = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbNI[i], false);
      }
      if (this.lockedKU) {
        tempData.enabledKU = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbKU[i], false);
      }

      this.relatedDataList[i] = tempData;
    }
  }

  /**
   * 指定行のデータをクリアする
   *
   * @param {number} index 行
   * @param {string} pCode Ｐコード
   * @memberof KYMW0500Model
   */
  public clearRowData(index: number, pCode: string): void {

    const tempData: RelatedDataModel = this.relatedDataList[index];

    tempData.originPCode = pCode;
    tempData.pCode = pCode;
    tempData.guideGoodsName = '';                                               // 商品名
    tempData.guideStandardName = '';                                            // 規格名
    tempData.selectedIB = false;                                                // 選択状態（いばらき）
    tempData.selectedTO = false;                                                // 選択状態（とちぎ）
    tempData.selectedGU = false;                                                // 選択状態（ぐんま）
    tempData.selectedTI = false;                                                // 選択状態（ちば）
    tempData.selectedSA = false;                                                // 選択状態（さいたま）
    tempData.selectedTK = false;                                                // 選択状態（とうきょう）
    tempData.selectedNA = false;                                                // 選択状態（ながの）
    tempData.selectedNI = false;                                                // 選択状態（にいがた）
    tempData.selectedKU = false;                                                // 選択状態（クルコ）

    tempData.enabledIB = false;	// 活性状態（いばらき）
    tempData.enabledTO = false;	// 活性状態（とちぎ）
    tempData.enabledGU = false;	// 活性状態（ぐんま）
    tempData.enabledTI = false;	// 活性状態（ちば）
    tempData.enabledSA = false;	// 活性状態（さいたま）
    tempData.enabledTK = false;	// 活性状態（とうきょう）
    tempData.enabledNA = false;	// 活性状態（ながの）
    tempData.enabledNI = false;	// 活性状態（にいがた）
    tempData.enabledKU = false;	// 活性状態（クルコ）


    switch (index) {
      case 1 :                                                                  // 子商品群2行目
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Ibaraki1, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tochigi1, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Gunma1, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Chiba1, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Saitama1, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tokyo1, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Nagano1, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Niigata1, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Kuruco1, false);
        break;
      case 2 :                                                                  // 子商品群3行目
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Ibaraki2, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tochigi2, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Gunma2, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Chiba2, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Saitama2, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tokyo2, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Nagano2, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Niigata2, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Kuruco2, false);
        break;
      case 3 :                                                                  // 子商品群4行目
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Ibaraki3, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tochigi3, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Gunma3, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Chiba3, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Saitama3, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tokyo3, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Nagano3, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Niigata3, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Kuruco3, false);
        break;
      case 4 :                                                                  // 子商品群5行目
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Ibaraki4, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tochigi4, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Gunma4, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Chiba4, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Saitama4, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tokyo4, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Nagano4, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Niigata4, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Kuruco4, false);
        break;
      case 5 :                                                                  // 子商品群6行目
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Ibaraki5, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tochigi5, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Gunma5, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Chiba5, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Saitama5, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tokyo5, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Nagano5, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Niigata5, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Kuruco5, false);
        break;
      case 6 :                                                                  // 子商品群7行目
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Ibaraki6, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tochigi6, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Gunma6, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Chiba6, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Saitama6, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tokyo6, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Nagano6, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Niigata6, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Kuruco6, false);
        break;
      case 7 :                                                                  // 子商品群8行目
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Ibaraki7, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tochigi7, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Gunma7, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Chiba7, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Saitama7, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tokyo7, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Nagano7, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Niigata7, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Kuruco7, false);
        break;
      case 8 :                                                                  // 子商品群9行目
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Ibaraki8, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tochigi8, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Gunma8, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Chiba8, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Saitama8, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Tokyo8, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Nagano8, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Niigata8, false);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.chk_Kuruco8, false);
        break;
    }

    this.relatedDataList[index] = tempData;
  }

  /**
   * 紐付設定画面データを取得する
   *
   * @private
   * @param {RelatedDataModel} targetVO
   * @param {*} [objData=null]
   * @param {boolean} [enabledPCode=false]
   * @param {number} index
   * @returns {RelatedDataModel}
   * @memberof KYMW0500Model
   */
  private getRelatedDataVO(targetVO: RelatedDataModel, objData: any = null, enabledPCode = false,
    index: number): RelatedDataModel {
    // 初期化
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpPCode[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbIB[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTO[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbGU[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTI[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbSA[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTK[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbNA[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbNI[index], false);
    this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbKU[index], false);

    targetVO.enabledIB = false;
    targetVO.enabledTO = false;
    targetVO.enabledGU = false;
    targetVO.enabledTI = false;
    targetVO.enabledSA = false;
    targetVO.enabledTK = false;
    targetVO.enabledNA = false;
    targetVO.enabledNI = false;
    targetVO.enabledKU = false;

    if (objData == null) {

      targetVO.originPCode = '';
      targetVO.pCode = '';
      targetVO.guideGoodsName = '';
      targetVO.guideStandardName = '';
      targetVO.enabledPCode = this.editMode;
      this.kymw0500Component.plessEnabled(this.kymw0500Component.grpPCode[index], this.editMode);

      targetVO.selectedIB = false;
      targetVO.selectedTO = false;
      targetVO.selectedGU = false;
      targetVO.selectedTI = false;
      targetVO.selectedSA = false;
      targetVO.selectedTK = false;
      targetVO.selectedNA = false;
      targetVO.selectedNI = false;
      targetVO.selectedKU = false;
    } else {
      if (objData.LockedIB != null) {
        if (objData.LockedIB && objData.LockedIB === 'true') {
          this.lockedIB = true;
        }
      }
      if (objData.LockedTO != null) {
        if (objData.LockedTO && objData.LockedTO === 'true') {
          this.lockedTO = true;
        }
      }
      if (objData.LockedGU != null) {
        if (objData.LockedGU && objData.LockedGU === 'true') {
          this.lockedGU = true;
        }
      }
      if (objData.LockedTI != null) {
        if (objData.LockedTI && objData.LockedTI === 'true') {
          this.lockedTI = true;
        }
      }
      if (objData.LockedSA != null) {
        if (objData.LockedSA && objData.LockedSA === 'true') {
          this.lockedSA = true;
        }
      }
      if (objData.LockedTK != null) {
        if (objData.LockedTK && objData.LockedTK === 'true') {
          this.lockedTK = true;
        }
      }
      if (objData.LockedNA != null) {
        if (objData.LockedNA && objData.LockedNA === 'true') {
          this.lockedNA = true;
        }
      }
      if (objData.LockedNI != null) {
        if (objData.LockedNI && objData.LockedNI === 'true') {
          this.lockedNI = true;
       }
      }
      if (objData.LockedKU != null) {
        if (objData.LockedKU && objData.LockedKU === 'true') {
          this.lockedKU = true;
        }
      }

      targetVO.originPCode = objData.PCode;
      targetVO.pCode = objData.PCode;
      targetVO.guideGoodsName = objData.GuideGoodsName;
      targetVO.guideStandardName = objData.GuideStandardName;

      targetVO.selectedIB = objData.SelectedIB === 'true' ? true : false;
      targetVO.selectedTO = objData.SelectedTO === 'true' ? true : false;
      targetVO.selectedGU = objData.SelectedGU === 'true' ? true : false;
      targetVO.selectedTI = objData.SelectedTI === 'true' ? true : false;
      targetVO.selectedSA = objData.SelectedSA === 'true' ? true : false;
      targetVO.selectedTK = objData.SelectedTK === 'true' ? true : false;
      targetVO.selectedNA = objData.SelectedNA === 'true' ? true : false;
      targetVO.selectedNI = objData.SelectedNI === 'true' ? true : false;
      targetVO.selectedKU = objData.SelectedKU === 'true' ? true : false;

      if (this.editMode) {
        targetVO.enabledPCode = enabledPCode;
        targetVO.enabledIB = objData.EnabledIB === 'true' ? true : false;
        targetVO.enabledTO = objData.EnabledTO === 'true' ? true : false;
        targetVO.enabledGU = objData.EnabledGU === 'true' ? true : false;
        targetVO.enabledTI = objData.EnabledTI === 'true' ? true : false;
        targetVO.enabledSA = objData.EnabledSA === 'true' ? true : false;
        targetVO.enabledTK = objData.EnabledTK === 'true' ? true : false;
        targetVO.enabledNA = objData.EnabledNA === 'true' ? true : false;
        targetVO.enabledNI = objData.EnabledNI === 'true' ? true : false;
        targetVO.enabledKU = objData.EnabledKU === 'true' ? true : false;

        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpPCode[index], enabledPCode);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbIB[index], targetVO.enabledIB);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTO[index], targetVO.enabledTO);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbGU[index], targetVO.enabledGU);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTI[index], targetVO.enabledTI);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbSA[index], targetVO.enabledSA);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbTK[index], targetVO.enabledTK);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbNA[index], targetVO.enabledNA);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbNI[index], targetVO.enabledNI);
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpCbKU[index], targetVO.enabledKU);
      } else {
        targetVO.enabledPCode = false;
        this.kymw0500Component.plessEnabled(this.kymw0500Component.grpPCode[index], false);
      }
    }

    return targetVO;
  }
}
